export const CUSTOM_BACKGROUND_COLORS = {
    colors: [
        {
            color: 'rgb(230, 230, 230)',
            label: 'Light Gray',
            class: 'ck-bg-light-gray',
        },
        {
            color: 'rgb(255, 255, 255)',
            label: 'White',
            class: 'ck-bg-white',
        },
        {
            color: 'rgb(153, 230, 77)',
            label: 'Light Green',
            class: 'ck-bg-light-green',
        },
        {
            color: 'rgb(77, 230, 77)',
            label: 'Bright Green',
            class: 'ck-bg-bright-green',
        },
        {
            color: 'rgb(77, 77, 230)',
            label: 'Bright Blue',
            class: 'ck-bg-bright-blue',
        },
        {
            color: 'rgb(153, 77, 230)',
            label: 'Purple',
            class: 'ck-bg-purple',
        },
    ],
};
